import { IKnmEvent248 } from 'APIPackage/KnmModule/interfaces/IKnmEvent248';
import { createKnmErknmFormEventSelectOption } from 'CorePackage/CatalogsModule/common/createKnmErknmFormEventSelectOption';
import {
  DATE_FORMAT_LONG_MINUTE_FNS,
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_FNS,
  SYSTEM_DATE_FORMAT_FNS,
} from 'CorePackage/MainModule/constants/dateFormats';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { IKnmDistrictSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmDistrictSelectOption';
import { getDistrictSelectOptions } from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { IKnmErknmFormEvent } from '../interfaces/IKnmErknmFormEvent';
import { IKnmErknmFormSuspensionEvent } from '../interfaces/IKnmErknmFormSuspensionEvent';

export const convertSuspensionEventsToFormData = (
  event: IKnmEvent248,
  formEvent: IKnmErknmFormEvent | undefined,
  index: number,
  state: IRootState,
): IKnmErknmFormSuspensionEvent[] => {
  const list = getDistrictSelectOptions(state);

  return (
    event.suspension?.map(stopItem => {
      let region: IKnmDistrictSelectOption | undefined;
      let fiasRegion: IKnmDistrictSelectOption | undefined;

      if (list && stopItem.region) {
        region = list.find(i => i.id.toString() === stopItem.region);
      }
      if (list && stopItem.fiasRegion) {
        fiasRegion = list.find(i => i.id.toString() === stopItem.fiasRegion);
      }

      return {
        guid: stopItem.guid || undefined,
        attachments: stopItem.attachments || undefined,
        event: formEvent && createKnmErknmFormEventSelectOption(formEvent, index),
        decisionDateTime: convertInitialKnmDateToFormDate(
          stopItem.decisionDateTime,
          DATE_FORMAT_LONG_MINUTE_FNS,
          DATE_FORMAT_ISO_FNS,
        ),
        decisionNumber: stopItem.decisionNumber || undefined,
        decisionPlace: stopItem.decisionPlace || undefined,
        startDate: convertInitialKnmDateToFormDate(stopItem.startDate, DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS),
        stopDate: convertInitialKnmDateToFormDate(stopItem.stopDate, DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS),
        isWorkDaysOnly: stopItem.isWorkDaysOnly || undefined,
        isInitStopDateFilled: !!stopItem.stopDate,
        dateCreate: stopItem.dateCreate || undefined,
        suspensionDays: typeof stopItem.suspensionDays === 'number' ? stopItem.suspensionDays : undefined,
        manualAddress: stopItem.manualAddress || undefined,
        notInFIAS: stopItem.notInFIAS || undefined,
        region,
        fiasRegion,
        completed: stopItem.completed || undefined,
      };
    }) || []
  );
};
